import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=bdab8938&scoped=true"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"
import style0 from "./Query.vue?vue&type=style&index=0&id=bdab8938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdab8938",
  null
  
)

export default component.exports